module.exports = __webpack_public_path__ + "img/basket.2c89a27e.svg";